import { Card, ScrollView, Stack, XStack } from '@ninjacart/nc-nk-ui';
import { View } from 'react-native';
import { Placeholder, PlaceholderLine, PlaceholderMedia, Shine } from 'rn-placeholder';

export const QnAPlaceHolder = ({ showDetailPage }:{showDetailPage:boolean}) => {
  return (
    <>
      <ScrollView showsVerticalScrollIndicator={false}>
        {showDetailPage && (
          <Card
            width={'100vw'}
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            margin={5}
            shadowOpacity={0.2}
            marginTop={70}
            paddingTop={20}
            paddingHorizontal={15}
            backgroundColor="$background"
          >
            <Placeholder Animation={Shine}>
              <PlaceholderLine width={80} />
              <Stack width={'100%'} display="flex">
                <PlaceholderLine
                  width={80}
                  style={[{ width: '100%', height: 45, borderRadius: 10, marginRight: 10 }]}
                />
              </Stack>
            </Placeholder>
          </Card>
        )}
        <View style={{ flex: 1 }}>
          <Card
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            marginHorizontal={5}
            shadowOpacity={0.2}
            marginVertical={10}
            backgroundColor="$background"
          >
            <Stack padding={10}>
              <Placeholder
                Animation={Shine}
                Left={(props) => <PlaceholderMedia isRound={true} style={[props.style]} />}
              >
                <PlaceholderLine width={80} />
                <PlaceholderLine width={30} />
              </Placeholder>
              <Placeholder Animation={Shine}>
                <XStack>
                  <PlaceholderMedia
                    style={[{ width: 100, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 100, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 80, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                </XStack>
                <PlaceholderMedia
                  style={[{ width: 300, height: 10, marginLeft: 25, marginTop: 10 }]}
                />
                <PlaceholderMedia
                  style={[{ width: 300, height: 10, marginLeft: 25, marginTop: 10 }]}
                />
                <XStack>
                  <PlaceholderMedia
                    style={[{ width: 110, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 110, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 100, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                </XStack>
                <XStack marginVertical={10} paddingHorizontal={10} justifyContent="space-between">
                  <PlaceholderMedia style={[{ width: 120, height: 20, marginTop: 10 }]} />
                  <PlaceholderMedia style={[{ width: 120, height: 20, marginTop: 10 }]} />
                </XStack>
              </Placeholder>
            </Stack>
          </Card>
          <Card
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            marginHorizontal={5}
            shadowOpacity={0.2}
            marginVertical={10}
            backgroundColor="$background"
          >
            <Stack padding={10}>
              <Placeholder
                Animation={Shine}
                Left={(props) => <PlaceholderMedia isRound={true} style={[props.style]} />}
              >
                <PlaceholderLine width={80} />
                <PlaceholderLine width={30} />
              </Placeholder>
              <Placeholder Animation={Shine}>
                <XStack>
                  <PlaceholderMedia
                    style={[{ width: 100, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 100, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 80, height: 20, marginLeft: 25, marginTop: 10 }]}
                  />
                </XStack>
                <PlaceholderMedia
                  style={[{ width: 300, height: 10, marginLeft: 25, marginTop: 10 }]}
                />
                <PlaceholderMedia
                  style={[{ width: 300, height: 10, marginLeft: 25, marginTop: 10 }]}
                />
                <XStack>
                  <PlaceholderMedia
                    style={[{ width: 110, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 110, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                  <PlaceholderMedia
                    style={[{ width: 100, height: 110, marginLeft: 10, marginTop: 10 }]}
                  />
                </XStack>
                <XStack marginVertical={10} paddingHorizontal={10} justifyContent="space-between">
                  <PlaceholderMedia style={[{ width: 120, height: 20, marginTop: 10 }]} />
                  <PlaceholderMedia style={[{ width: 120, height: 20, marginTop: 10 }]} />
                </XStack>
              </Placeholder>
            </Stack>
          </Card>
        </View>
      </ScrollView>
    </>
  );
};
